import React from "react";
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import ArrowRightIcon from "../assets/icons/arrow-right.svg";

import platform_for_all_1 from '../assets/images/platform_for_all_1.jpg';
import platform_for_all_2 from '../assets/images/platform_for_all_2.png';
import platform_for_all_3 from '../assets/images/platform_for_all_3.png';
import platform_for_all_4 from '../assets/images/platform_for_all_4.jpg';

const IMAGE_MAP = {
  'platform_for_all_1.jpg': platform_for_all_1,
  'platform_for_all_2.png': platform_for_all_2,
  'platform_for_all_3.png': platform_for_all_3,
  'platform_for_all_4.jpg': platform_for_all_4,
};

function BlockInfo({
  title = "...",
  description = "...",
  action = "",
  img = "platform_for_all_1.jpg",
  url = "#"
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1.2rem",
        maxWidth: "42rem",
        borderRadius: "15px",
        width: "100%"
      }}

      data-aos="flip-left"
      data-aos-duration="700"
      data-aos-easing="ease-in-sine"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 'fit-content',
          alignItems: { xs: "center", sm: 'flex-start' },
          // justifyContent: { xs: "center", sm: 'left' },
          textAlign: { xs: 'center', sm: 'left' },

        }}
      >
        {/* IMAGE */}
        <Box
          sx={{
            position: "relative",
            width: "28rem",
            height: "24rem",
            opacity: 1,
            backgroundImage: `url(${IMAGE_MAP[img]})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            borderRadius: '25px',
            marginBottom: '2.4rem',
          }}
        ></Box>

        {/* TITLE */}
        <Typography
          sx={{
            color: "#fff",
            fontSize: '2.4rem',
            fontWeight: 700,
            lineHeight: { xs: '2.8rem', md: '2.5rem' },
            marginBottom: '2.4rem',
          }}
        >
          {title}
        </Typography>

        {/* DESCRIPTION */}
        <Typography
          sx={{
            color: "#FEFFFACC",
            fontSize: '1.5rem',
            fontWeight: 400,
            lineHeight: '2rem',
            maxWidth: '25ch',
            minHeight: { xs: 'none', sm: '16rem' },
          }}
        >
          {description}
        </Typography>

        {/* ACTION */}
        {action.length ? <Box
          component="a"
          href={url}
          sx={{
            color: 'white',
            fontSize: '1.8rem',
            fontWeight: 500,
            cursor: "pointer",
            ":hover": {
              fontWeight: 700,
            },
            display: "flex",
            alignItems: "center",
            gap: "5px",
            marginTop: "2.4rem",
            lineHeight: "4rem",
            width: "fit-content",
          }}>

          {action}
          <Box
            component="img"
            src={ArrowRightIcon}
            alt="Arrorw right icon"
            mt="4px"
            sx={{
              objectFit: "contain",
              height: "2rem",
            }}
          />
        </Box> : <></>}
      </Box>
    </Box >
  );
}

BlockInfo.propTypes = {
  window: PropTypes.func,
};

export default BlockInfo;